import type { SVGProps } from 'react';
const SvgIconCalendarFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} {...props}>
    <path
      fill="#3E704B"
      d="M8.429 5.143v1.143H6.714C5.768 6.286 5 7.054 5 8v1.714h16V8c0-.946-.768-1.714-1.714-1.714H17.57V5.143a1.142 1.142 0 1 0-2.285 0v1.143h-4.572V5.143a1.142 1.142 0 1 0-2.285 0zM21 10.857H5v9.714c0 .947.768 1.715 1.714 1.715h12.572c.946 0 1.714-.768 1.714-1.715z"
    />
  </svg>
);
export default SvgIconCalendarFilled;
